import { RealtimeInterface } from '../services/realtime/realtime-interface';
import { Entity } from './entity.class';

export class EntityUnavailable implements RealtimeInterface {
    id: number;
    entity_id: number;
    description: string;
    begindate: Date;
    enddate: Date;
    entity: Entity;
}
